// Fire-and-forget client-error beacon. Sends the error to the server so we can
// diagnose device-specific crashes (e.g. an iOS PWA that errors on launch) that
// we can't reproduce. Never throws.
export function reportClientError(source: string, e: unknown) {
  try {
    const err = e as { message?: string; stack?: string; digest?: string } | undefined;
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as unknown as { standalone?: boolean }).standalone === true;
    const payload = JSON.stringify({
      source,
      message: String(err?.message ?? e ?? ''),
      stack: String(err?.stack ?? ''),
      digest: String(err?.digest ?? ''),
      url: location.href,
      standalone,
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/v1/clientlog', new Blob([payload], { type: 'application/json' }));
    } else {
      fetch('/api/v1/clientlog', {
        method: 'POST',
        body: payload,
        keepalive: true,
        headers: { 'content-type': 'application/json' },
      }).catch(() => {});
    }
  } catch {
    /* never throw from the reporter */
  }
}
